module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-02.1.11f18939.jpg";